import { Box, FlexProps } from 'pounceV2';
import React from 'react';
import useRouter from 'Hooks/useRouter';
import { addTrailingSlash, getPathnameFromURI } from 'Helpers/utils';
import { Link as RRLink } from 'react-router-dom';
import NavLinkContentV3 from './NavLinkContentV3';
import { NavigationLink } from '../types';

const NavLinkV3 = ({
  icon,
  testId,
  label,
  to,
  isSecondary,
  ...flexProps
}: NavigationLink & FlexProps) => {
  const { location } = useRouter();
  const pathname = addTrailingSlash(location.pathname);
  const destination = addTrailingSlash(getPathnameFromURI(to));
  const isActive = pathname.startsWith(destination);

  return (
    <Box as={RRLink} to={to} data-tid={testId} aria-current={isActive ? 'page' : undefined}>
      <NavLinkContentV3
        icon={icon}
        label={label}
        isSecondary={isSecondary}
        isActive={isActive}
        {...flexProps}
      />
    </Box>
  );
};

export default NavLinkV3;
